// Please leave 'en' where it is, as it's our fallback language in case no translation can be found
// SLG Comment : Support only en and fr locales
export const SupportedTranslationLocales: string[] = ["en", "fr"];
